import { render, staticRenderFns } from "./StreamName.vue?vue&type=template&id=64c8207f&scoped=true&"
import script from "./StreamName.vue?vue&type=script&lang=js&"
export * from "./StreamName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c8207f",
  null
  
)

export default component.exports